export default "__VITE_ASSET__Ch08lMI9__"